import React, { useEffect, useState, useContext } from "react";
import Videocontainer from "./Videocontainer";
import MyContext from "../../../../context/MyContext";
import Lottie from "react-lottie";
import loader from "../../../../assets/Loader/AssetLoader.json";

export const PexelsVideos = (props) => {
  const { VideoData, setVideoData, setisTextInputOrAreaFocus } =
    useContext(MyContext);

  const [popularTemp, setpopularTemp] = useState(null);

  const [MyLoader, setMyLoader] = useState(false);

  useEffect(() => {
    if (VideoData.apiData.length === 0) {
      setMyLoader(true);
      fetch("https://api.pexels.com/videos/popular?per_page=80", {
        headers: {
          Authorization:
            "563492ad6f917000010000017dd498c23d754c06b5e9b98f8ec9b19a",
        },
      }).then((response) => {
        if (!response.ok) {
          throw Error("not working");
        }
        return response
          .json()
          .then((allData) => {
            setMyLoader(false);
            setpopularTemp(true);
            setVideoData({
              ...VideoData,
              apiData: allData.videos,
            });
          })
          .catch((err) => {
            setMyLoader(false);
            throw Error(err.message);
          });
      });
    }
  }, []);

  function isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }

  const handlechange = (e) => {
    if (e.key === "Enter") {
      if (isEmptyOrSpaces(e.target.value)) {
        if (!popularTemp) {
          setMyLoader(true);
          fetch("https://api.pexels.com/videos/popular?per_page=80", {
            headers: {
              Authorization:
                "563492ad6f917000010000017dd498c23d754c06b5e9b98f8ec9b19a",
            },
          }).then((response) => {
            setMyLoader(false);
            if (!response.ok) {
              throw Error("not working");
            }
            return response
              .json()
              .then((allData) => {
                setpopularTemp(true);
                setVideoData({
                  ...VideoData,
                  apiData: allData.videos,
                });
              })
              .catch((err) => {
                setMyLoader(false);
                throw Error(err.message);
              });
          });
        }
      } else {
        setMyLoader(true);
        fetch(
          `https://api.pexels.com/videos/search?query=${e.target.value}&per_page=80`,
          {
            headers: {
              Authorization:
                "563492ad6f917000010000017dd498c23d754c06b5e9b98f8ec9b19a",
            },
          }
        ).then((response) => {
          setMyLoader(false);
          if (!response.ok) {
            throw Error("not working");
          }
          return response
            .json()
            .then((allData) => {
              setpopularTemp(false);
              setVideoData({
                ...VideoData,
                apiData: allData.videos,
              });
            })
            .catch((err) => {
              setMyLoader(false);
              throw Error(err.message);
            });
        });
      }
    }
  };

  return (
    <>
      <div className="searchBarParent" style={{ padding: "0px 12px" }}>
        <span className="material-icons SearchIconCustom">search</span>
        <input
          className="search customInput searchpad mb-1"
          type="search"
          placeholder="Search Videos..."
          onKeyDown={handlechange}
          onFocus={() => setisTextInputOrAreaFocus(true)}
          onBlur={() => setisTextInputOrAreaFocus(false)}
        />
      </div>
      <div className="p2" style={{ height: "100%" }}>
        {!MyLoader && VideoData.apiData != null && (
          <Videocontainer Vid={VideoData.apiData} />
        )}

        {MyLoader && (
          <Lottie
            options={{ loop: true, autoplay: true, animationData: loader }}
            height={200}
            width={200}
            isStopped={false}
            isPaused={false}
          />
        )}
      </div>
    </>
  );
};
export default PexelsVideos;
